import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_STUDENT_TOTAL_POINTS_REQUEST = 'FETCH_STUDENT_TOTAL_POINTS_REQUEST';
export const FETCH_STUDENT_TOTAL_POINTS_SUCCESS = 'FETCH_STUDENT_TOTAL_POINTS_SUCCESS';
export const FETCH_STUDENT_TOTAL_POINTS_FAILURE = 'FETCH_STUDENT_TOTAL_POINTS_FAILURE';

const buildHomeworkUrl = (groupId) => buildUrl(`/groups/${groupId}/student-total-point/`);
export function fetchStudentTotalPoints(groupId) {
  return (dispatch) => {
    const url = buildHomeworkUrl(groupId);
    const method = 'GET';

    return dispatch(fetchStudentTotalPointsRequest()).payload
        .then((response) => dispatch(fetchStudentTotalPointsSuccess(response)))
        .catch((error) => dispatch(fetchStudentTotalPointsfailure(error)));

    function fetchStudentTotalPointsRequest() {
      return ApiCall.createAction({
        type: FETCH_STUDENT_TOTAL_POINTS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchStudentTotalPointsSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_TOTAL_POINTS_SUCCESS,
        payload: response,
        url,
        method,
        groupId,
      });
    }

    function fetchStudentTotalPointsfailure(error) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_TOTAL_POINTS_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/OnlineHomework/TotalPoint/actions.js